<template>
  <div>
    <vxe-card>
      <div slot="title">
        <vxe-button content="tab.details" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="zone" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.zoneNo')" prop="no">
              <vxe-input v-model="zone.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.zoneName')" prop="name">
              <vxe-input v-model="zone.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.zoneType')" prop="zoneType">
              <vxe-select v-model="zone.zoneType" :options="zoneTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.storageRoom')" prop="storageRoom">
              <vxe-input v-model="zone.storageRoom.name" style="width: 100%" @clear="onInputChange(zone,'storageRoom')" @click="onStorageRoomSelect"/>
            </a-form-model-item>
            <storage-room-modal ref="storageRoomModal" @change="(values)=>onInputChange(zone,'storageRoom',values[0])"/>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.floor')" prop="floor">
              <vxe-number-input v-model="zone.floor" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.bigRegion')" prop="region">
              <vxe-select v-model="zone.region.id" :options="regions" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.fetchMode')" prop="fetchMode">
              <vxe-select v-model="zone.fetchMode" :options="fetchModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.putawayMode')" prop="putawayMode">
              <vxe-select v-model="zone.putawayMode" :options="putawayModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.transmissionType')" prop="transmissionType">
              <vxe-select v-model="zone.transmissionType" :options="transmissionTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.seedingMode')" prop="seedingMode">
              <vxe-select v-model="zone.seedingMode.id" :options="seedingModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.packingMode')" prop="packingMode">
              <vxe-select v-model="zone.packingMode.id" :options="packingModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.positionType')" prop="positionType">
              <vxe-select v-model="zone.positionType.id" :options="positionTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.stagingType')" prop="stagingType">
              <vxe-select v-model="zone.stagingType.id" :options="stagingTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.position')" prop="position">
              <vxe-input v-model="zone.position.no" style="width: 100%" @clear="onInputChange(zone,'position')" @click="onPositionSelect"/>
            </a-form-model-item>
            <location-modal ref="locationModal" @change="(values)=>onInputChange(zone,'position',values[0])"/>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.ordinal')" prop="ordinal">
              <vxe-number-input v-model="zone.ordinal" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.fullload')" prop="fullload">
              <vxe-number-input v-model="zone.fullload" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.automatic')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="zone.mechanical"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="工作站">
              <vxe-switch v-model="zone.workstation"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="单人作业">
              <vxe-switch v-model="zone.singleWork"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="转运">
              <vxe-switch v-model="zone.transfer"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="发送">
              <vxe-switch v-model="zone.sendable"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="分配">
              <vxe-switch v-model="zone.allocable"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="接力拣选">
              <vxe-switch v-model="zone.relay"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="自动索取">
              <vxe-switch v-model="zone.autoObtain"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label-col="wrapperCol" :wrapper-col="labelCol" label="自动确认">
              <vxe-switch v-model="zone.autoConfirm"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <workstation-config ref="config" :operation-types="operationTypes"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Zone } from '@/api/dto/common/Zone'
import WorkstationConfig from '@/views/basedata/zone/WorkstationConfig.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import { onInputChange } from '@/utils/util'

export default {
  name: 'ZoneDetail',
  components: { WorkstationConfig, StorageRoomModal, LocationModal },
  data() {
    return {
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      zone: new Zone(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        storageRoom: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        zoneType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        transmissionType: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    zoneTypes: {
      type: Array,
      default: []
    },
    regions: {
      type: Array,
      default: []
    },
    fetchModes: {
      type: Array,
      default: []
    },
    putawayModes: {
      type: Array,
      default: []
    },
    transmissionTypes: {
      type: Array,
      default: []
    },
    seedingModes: {
      type: Array,
      default: []
    },
    packingModes: {
      type: Array,
      default: []
    },
    positionTypes: {
      type: Array,
      default: []
    },
    stagingTypes: {
      type: Array,
      default: []
    },
    operationTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    onInputChange,
    back() {
      this.$emit('back')
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true })
    },
    onPositionSelect() {
      this.$refs.locationModal.open({ available: true, 'zone.id': this.zone.id })
    },
    fetch(id) {
      this.loading = true
      findOne('zoneFactory', { id: id }).then(res => {
        if (res.success) {
          this.zone = new Zone(res.result)
          this.$refs.config.fetch(this.zone)
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.fetch(this.user.id)
    },
    add() {
      this.zone = new Zone()
      this.zone.available = true
    },
    save() {
      this.$refs.form.validate(success => {
        if (success) {
          this.loading = true
          const zone = this.zone.toJSONObject()
          zone.warehouse = this.warehouse
          save('zonePersister', zone).then(res => {
            if (res.success) {
              this.zone = new Zone(res.result)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    },
    enable(row, available) {
      this.fetch(row.id)
      this.zone.available = available
      this.save()
    }
  }
}
</script>